// Support (Freshdesk) module entry point. The route in src/Routes/allRoutes.js
// imports this; it renders the full Support workspace.
import SupportDashboard from "./SupportDashboard";

export default SupportDashboard;
